<script>
import Layout from "../../../../../layouts/main";
import appConfig from "@/app.config";
export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {
      salaryItems: [],
      levelThreeAccounts: [],
      branch: {},
      branchItem: {
        isNew: 1,
        item: {},
        code: null,
        account: null,
      },
    };
  },
  methods: {
    getCode() {
      this.http.post("cash-accounts/codes", { type: "cash" }).then((res) => {
        this.branchItem.code = res.data[0].code;
      });
    },
    selectedAccount(account) {
      this.http
        .post("cash-accounts/level-three/search", {
          search: account,
          module_name: "Cash",
        })
        .then((res) => {
          if (res.status) {
            this.levelThreeAccounts = res.data.map((a) => {
              return this.$i18n.locale == "ar"
                ? a.code + "-" + a.name
                : a.code + "-" + a.name_en;
            });
          }
        });
    },
    addItem() {
      console.log(this.branchItem);
      this.http
        .post("cash-accounts/cash", {
          branchItem: this.branchItem,
        })
        .then((res) => {
          if (res.status) {
            this.branchItem = {
              isNew: 1,
              item: {},
              code: null,
              account: null,
            };
            this.$router.push("/cash_and_banks");
          }
        });
    },
    getBranch() {
      const currentUser = JSON.parse(localStorage.currentUser);
      this.http.get("branches/" + currentUser.branch_id).then((res) => {
        this.branch = res.data;
      });
    },
  },
  computed: {
    filteredAccounts() {
      return this.levelThreeAccounts.filter((account) => {
        return account;
      });
    },
  },
  created() {
    this.getBranch();
    this.getCode();
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="row align-items-center">
        <div class="d-flex align-items-center mb-4">
          <router-link :to="`/cash_and_banks`">
            <h4 class="m-0">
              {{ $t("cash_banks.title") }}
            </h4>
          </router-link>
          <div class="mx-2">\</div>
          <div>
            {{
              $t("cash_banks.add") +
              ` (${$i18n.locale == "ar" ? branch?.name : branch?.name_en})`
            }}
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row p-2" style="background-color: rgb(239, 237, 237)">
              <form class="mb-3" @submit.prevent="addItem">
                <div class="mb-3">
                  <label for="">{{ $t("popups.name_ar") }}</label>
                  <input
                    required
                    v-model="branchItem.name"
                    type="text"
                    class="form-control"
                  />
                </div>
                <div class="mb-3">
                  <label for="">{{ $t("popups.name_en") }}</label>
                  <input
                    required
                    v-model="branchItem.name_en"
                    type="text"
                    class="form-control"
                  />
                </div>
                <div class="mb-3">
                  <label for="">{{ $t("popups.creditdebit") }}</label
                  ><br />
                  <select required v-model="branchItem.credDebit">
                    <option value=" ">{{ "" }}</option>
                    <option value="1">{{ $t("popups.credti") }}</option>
                    <option value="0">{{ $t("popups.debit") }}</option>
                  </select>
                </div>

                <div class="mb-3" v-if="parseInt(branchItem.isNew)">
                  <label for="">{{ $t("salaryItems.table.code") }}</label>
                  <input
                    disabled
                    v-model="branchItem.code"
                    required
                    type="number"
                    class="form-control"
                  />
                </div>

                <hr class="mt-2" />
                <div
                  class="float-end"
                  :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
                >
                  <button
                    @click="$router.back()"
                    style="margin-inline-end: 4px"
                    type="button"
                    class="btn btn-secondary"
                  >
                    {{ $t("popups.cancel") }}
                  </button>
                  <button type="submit" class="btn btn-primary">
                    {{ $t("popups.add") }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style scoped></style>
